export const DOCS = "https://docs.effica.kz";
export const PWA_ARTICLE_URL = `${DOCS}/docs/pwa-instruction/`;
